// var isProduction = process.env.NODE_ENV === 'production'

import Vue from 'vue'
import Router from 'vue-router'

// 登录页
import Login from '@/page/common/Login'
// 系统主页面
import Main from '@/page/common/Main'
// 欢迎页面
import Welcome from '@/page/common/Welcome'
// 个人管理页面
import AdminUserInfo from '@/page/common/AdminUserInfo'
// === 权限相关 START ===
// 部门员工管理
import DepartmentStaffManagement from '@/page/system/DepartmentStaffManagement'
// 菜单管理
import ModuleManagement from '@/page/system/ModuleManagement'
// 角色管理
import LabelManagement from '@/page/system/LabelManagement'
// === 权限相关 END ===

import CooperativeManage from '@/page/other/CooperativeManage'
import MemberLeaveMessage from '@/page/other/MemberLeaveMessage'
import ProblemFeedBack from '@/page/other/ProblemFeedBack'
import StaffmienManage from '@/page/other/StaffmienManage'
import StaffmienTypeManage from '@/page/other/StaffmienTypeManage'

import BannerManage from '@/page/config/BannerManage'
import ConfigManage from '@/page/config/ConfigManage'
import ContactManage from '@/page/config/ContactManage'
import ProductionBaseManage from '@/page/config/ProductionBaseManage'

import CaseManage from '@/page/cms/CaseManage'
import CaseTypeManage from '@/page/cms/CaseTypeManage'
import DownfileManage from '@/page/cms/DownfileManage'
import DownfileTypeManage from '@/page/cms/DownfileTypeManage'
import NavigateionManage from '@/page/cms/NavigateionManage'
import NewsManage from '@/page/cms/NewsManage'
import NewsTypeManage from '@/page/cms/NewsTypeManage'
import ProductManage from '@/page/cms/ProductManage'
import ProductTypeManage from '@/page/cms/ProductTypeManage'
import VideoManage from '@/page/cms/VideoManage'
import SinglePageManage from '@/page/cms/SinglePageManage'
import IndexConfigSetting from '@/page/cms/IndexConfigSetting'
import ProductQuestionManage from '@/page/cms/ProductQuestionManage'

import ProductSSGT from '@/page/product/ProductSSGT'
import ProductTypeSSGT from '@/page/product/ProductTypeSSGT'

// 新增模块 2018年12月27日
// 产品用户类型管理
import ProductMemberTypeManagement from '@/page/product/ProductMemberTypeManagement'
// 产品用户管理
import ProductMemberManagement from '@/page/product/ProductMemberManagement'
// 用户数量系数管理
import ProductNumberConfigManagement from '@/page/product/ProductNumberConfigManagement'
// 在线询价查看
import EnquiryOnlineSubmitManagement from '@/page/product/EnquiryOnlineSubmitManagement'
// 在线询价配置管理
import EnquiryOnlineConfigManagement from '@/page/product/EnquiryOnlineConfigManagement'

// 项目信息录入
// import ProjectInfo from '@/page/ProjectInfo'

Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/Login',
    name: 'Login',
    component: Login
  }, {
    path: '/',
    component: Main,
    children: [{
      path: '/',
      name: 'WelcomeIndex',
      component: Welcome
    }, {
      path: '/Welcome',
      name: 'Welcome',
      component: Welcome
    }, {
      path: '/AdminUserInfo',
      name: 'AdminUserInfo',
      component: AdminUserInfo
    }, {
      path: '/system/DepartmentStaffManagement',
      name: 'DepartmentStaffManagement',
      component: DepartmentStaffManagement
    }, {
      path: '/system/ModuleManagement',
      name: 'ModuleManagement',
      component: ModuleManagement
    }, {
      path: '/system/LabelManagement',
      name: 'LabelManagement',
      component: LabelManagement
    }, {
      path: '/config/BannerManage',
      name: 'BannerManage',
      component: BannerManage
    }, {
      path: '/config/ConfigManage',
      name: 'ConfigManage',
      component: ConfigManage
    }, {
      path: '/config/ProductionBaseManage',
      name: 'ProductionBaseManage',
      component: ProductionBaseManage
    }, {
      path: '/config/ContactManage',
      name: 'ContactManage',
      component: ContactManage
    }, {
      path: '/other/CooperativeManage',
      name: 'CooperativeManage',
      component: CooperativeManage
    }, {
      path: '/other/MemberLeaveMessage',
      name: 'MemberLeaveMessage',
      component: MemberLeaveMessage
    }, {
      path: '/other/ProblemFeedBack',
      name: 'ProblemFeedBack',
      component: ProblemFeedBack
    }, {
      path: '/other/StaffmienManage',
      name: 'StaffmienManage',
      component: StaffmienManage
    }, {
      path: '/other/StaffmienTypeManage',
      name: 'StaffmienTypeManage',
      component: StaffmienTypeManage
    }, {
      path: '/cms/CaseManage',
      name: 'CaseManage',
      component: CaseManage
    }, {
      path: '/cms/CaseTypeManage',
      name: 'CaseTypeManage',
      component: CaseTypeManage
    }, {
      path: '/cms/DownfileManage',
      name: 'DownfileManage',
      component: DownfileManage
    }, {
      path: '/cms/DownfileTypeManage',
      name: 'DownfileTypeManage',
      component: DownfileTypeManage
    }, {
      path: '/cms/NavigateionManage',
      name: 'NavigateionManage',
      component: NavigateionManage
    }, {
      path: '/cms/NewsManage',
      name: 'NewsManage',
      component: NewsManage
    }, {
      path: '/cms/NewsTypeManage',
      name: 'NewsTypeManage',
      component: NewsTypeManage
    }, {
      path: '/cms/ProductManage',
      name: 'ProductManage',
      component: ProductManage
    }, {
      path: '/cms/ProductTypeManage',
      name: 'ProductTypeManage',
      component: ProductTypeManage
    }, {
      path: '/cms/VideoManage',
      name: 'VideoManage',
      component: VideoManage
    }, {
      path: '/cms/SinglePageManage',
      name: 'SinglePageManage',
      component: SinglePageManage
    }, {
      path: '/product/ProductSSGT',
      name: 'ProductSSGT',
      component: ProductSSGT
    }, {
      path: '/product/ProductTypeSSGT',
      name: 'ProductTypeSSGT',
      component: ProductTypeSSGT
    }, {
      path: '/product/EnquiryOnlineSubmitManagement',
      name: 'EnquiryOnlineSubmitManagement',
      component: EnquiryOnlineSubmitManagement
    }, {
      path: '/product/EnquiryOnlineConfigManagement',
      name: 'EnquiryOnlineConfigManagement',
      component: EnquiryOnlineConfigManagement
    }, {
      path: '/product/ProductMemberManagement',
      name: 'ProductMemberManagement',
      component: ProductMemberManagement
    }, {
      path: '/product/ProductNumberConfigManagement',
      name: 'ProductNumberConfigManagement',
      component: ProductNumberConfigManagement
    }, {
      path: '/product/ProductMemberTypeManagement',
      name: 'ProductMemberTypeManagement',
      component: ProductMemberTypeManagement
    }, {
      path: '/cms/IndexConfigSetting',
      name: 'IndexConfigSetting',
      component: IndexConfigSetting
    }, {
      path: '/cms/ProductQuestionManage',
      name: 'ProductQuestionManage',
      component: ProductQuestionManage
    }]
  }]
})

router.beforeEach((to, from, next) => {
  // 获取登录用户信息, 成功(用户已登录)进入, 失败(用户未登录)跳转登录页
  router.app.$store.dispatch('getLoginMemberInfo').then(res => {
    // 已登录
    if (to.fullPath === '/Login') {
      // 如果登陆页自动跳转到首页
      next('/')
    }
    // 正常页面进入
    next()
  }, () => {
    // 未登录
    if (to.fullPath !== '/Login') {
      // 非登录页跳转登录页
      next('/Login')
    }
    // 直接进入登录页
    next()
  })
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js